import { html } from "lit";
var icon_tv_content_default = () => html`
  <svg viewBox="0 0 22 24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.25 6H2.75A2.25 2.25 0 00.5 8.25v12a2.25 2.25 0 002.25 2.25h16.5a2.25 2.25 0 002.25-2.25v-12A2.25 2.25 0 0019.25 6zM2.75 7.5h16.5a.75.75 0 01.75.75v12a.75.75 0 01-.75.75H2.75a.75.75 0 01-.75-.75v-12a.75.75 0 01.75-.75z" />
    <path
      d="M7.676 10.438a1.5 1.5 0 00-.711 1.276v5.072a1.5 1.5 0 002.17 1.342l5.073-2.536a1.502 1.502 0 00.002-2.683l-5.075-2.537a1.5 1.5 0 00-1.323-.008l-.136.074zm.789 6.348v-5.072l5.071 2.537-5.071 2.535zM2.75 21a.75.75 0 01.743.648l.007.102v1.5a.75.75 0 01-1.493.102L2 23.25v-1.5a.75.75 0 01.75-.75zm16.5 0a.75.75 0 01.743.648l.007.102v1.5a.75.75 0 01-1.493.102l-.007-.102v-1.5a.75.75 0 01.75-.75zM4.47.22a.75.75 0 01.976-.073L5.53.22 11 5.689l5.47-5.47a.75.75 0 01.976-.072l.084.073a.75.75 0 01.073.976l-.073.084-6 6a.75.75 0 01-.976.073l-.084-.073-6-6a.75.75 0 010-1.06z" />
  </svg>
`;
export {
  icon_tv_content_default as default
};
//# sourceMappingURL=icon-tv-content.js.map
